import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { GetAnalyticsDto, RoomUsageResponse } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getRoomUsage = async ({
  from,
  to,
  organisationId,
}: GetAnalyticsDto) => {
  const response = await axiosClient.get<RoomUsageResponse>(
    `/analytics/room-usage`,
    {
      params: {
        from,
        to,
        organisationId,
      },
    },
  );

  return response.data;
};

export function useGetRoomUsage(
  { from, to, organisationId }: GetAnalyticsDto,
  queryOptions?: Partial<UseQueryOptions<RoomUsageResponse, HttpError>>,
) {
  return useQuery({
    queryKey: ["analytics", "room-usage", from, to, organisationId],
    queryFn: () => getRoomUsage({ from, to, organisationId }),
    ...queryOptions,
  });
}
